import { render } from "./QuestionEdit.vue?vue&type=template&id=965d1b66"
import script from "./QuestionEdit.vue?vue&type=script&lang=js"
export * from "./QuestionEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__